import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";

const routes = [
  {
    path: "/",
    redirect: "exhibitions",
  },
  {
    path: "/login",
    component: () => import('../views/Login')
  },
  {
    path: "/horoscope",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "每日運勢",
        component: () => import('../views/Horoscope/DailyHoroscope')
      }
    ]
  },
  {
    path: "/exhibitions",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "展覽列表",
        component: () => import('../views/Exhibition/ExhibitionList')
      },
      {
        path: "v1/:id",
        name: "舊版過去展覽",
        component: () => import('../views/Exhibition/ExhibitionOlder')
      },
      {
        path: "v1/:exhibitionId/collections",
        name: "舊版展品列表",
        component: () => import('../views/Collection/CollectionList')
      },
      {
        path: "v1/:exhibitionId/collections/:collectionId",
        name: "舊版展品編輯",
        component: () => import('../views/Collection/CollectionOlder')
      },
      {
        path: "v2/:id",
        name: "編輯展覽",
        component: () => import('../views/Exhibition/ExhibitionEdit')
      },
      {
        path: "v2/:exhibitionId/collections",
        name: "展品列表",
        component: () => import('../views/Collection/CollectionList')
      },
      {
        path: "v2/:exhibitionId/collections/:collectionId",
        name: "展品編輯",
        component: () => import('../views/Collection/CollectionEdit')
      }
    ]
  },
  {
    path: "/beacons",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "裝置列表",
        component: () => import('../views/Beacon/BeaconList')
      },
      {
        path: ":id",
        name: "編輯裝置",
        component: () => import('../views/Beacon/BeaconEdit')
      },
    ]
  },
  {
    path: "/staffs",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "館方人員列表",
        component: () => import('../views/System/AccountList')
      },
      {
        path: ":id",
        name: "帳號設定",
        component: () => import('../views/System/AccountEdit')
      },
    ]
  },
  {
    path: "/permission",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "權限管理",
        component: () => import('../views/System/PermissionEdit')
      }
    ]
  },
  {
    path: "/account",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "個人帳號設定",
        component: () => import('../views/System/AccountEdit')
      }
    ]
  },
  {
    path: "/notification",
    component: DashboardLayout,
    redirect: "/notification/beacon",
    children: [
      {
        path: "beacon",
        name: "Beacon-推播管理",
        component: () => import('../views/Notification/BeaconNotificationList')
      },
      {
        path: "beacon/:beaconMessageId",
        name: "Beacon-推播編輯",
        component: () => import('../views/Notification/BeaconNotificationEdit')
      },
      {
        path: "firebase",
        name: "Firebase-推播管理",
        component: () => import('../views/Notification/FirebaseNotificationList')
      },
      {
        path: "gps",
        name: "GPS-推播管理",
        component: () => import('../views/Notification/GPSNotificationList')
      }
    ]
  },
  {
    path: "/artists",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "藝術家",
        component: () => import('../views/Artists/ArtistList')
      },
      {
        path: ":id",
        name: "藝術家編輯",
        component: () => import('../views/Artists/ArtistEdit'),
      }
    ]
  },
  {
    path: "/levels",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "關卡列表",
        component: () => import('../views/Level/LevelList')
      },
      {
        path: ":id",
        name: "關卡編輯",
        component: () => import('../views/Level/LevelEdit'),
      }
    ]
  },
  {
    path: "/infos",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "參觀資訊",
        component: () => import('../views/TfamInfo/Index')
      }
    ]
  },
  {
    path: "/transfer",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "轉換資料表",
        component: () => import('../views/TransferView')
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
// export default new VueRouter({
//   scrollBehavior() {
//     return { x: 0, y: 0 };
//   },
//   routes: routes,
//   mode: 'history'
// });
